import React, {useState} from 'react';
import PropTypes from 'prop-types';

//MUI
import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';

//BIKENTA
import InterventionZoneMenu from '../InterventionZones/InterventionZoneMenu/InterventionZoneMenu';

//GEOCOMPONENTS
import BottomSheet from '@geomatico/geocomponents/BottomSheet';

//UTILS
import {ROLES_LABEL} from '../../config';
import {prospectingPoints} from '../proptypes/prospectingPoints';
import {visit} from '../proptypes/visit';

//STYLES
const container = {
  position: 'relative',
  height: '45vh'
};

const InterventionZoneBottomSheet = ({
  isMaderaPlusMode,
  isOffline,
  maderaPlusAvailableSpecies,
  prospectingPoints,
  role,
  selectedInterventionZone,
  specie,
  visitList,
  onInterventionAdd,
  onMaderaPlusFormOpen,
  onMaderaPlusEnd,
  onInterventionSelect,
  onVisitAdd,
  onVisitDelete
}) => {
  const [isOpen, setOpen] = useState(true);
  const handleInterventionAdd = () => onInterventionAdd && onInterventionAdd();
  const handleSelectIntervention = (interventionId) => onInterventionSelect && onInterventionSelect(interventionId);

  return <Hidden lgUp>{/*MOBILE*/}
    <BottomSheet
      closedHeight={120}
      openHeight={'50vh'}
      onToggle={() => setOpen(!isOpen)}
      isOpen={isOpen}
    >
      <Box sx={container}>
        {
          selectedInterventionZone && <InterventionZoneMenu
            interventionZone={selectedInterventionZone}
            isMaderaPlusMode={isMaderaPlusMode}
            isOffline={isOffline}
            maderaPlusAvailableSpecies={maderaPlusAvailableSpecies}
            role={role}
            specie={specie}
            prospectingPoints={prospectingPoints}
            visitList={visitList}
            onShareClick={() => { }}
            onExportClick={() => { }}
            onMaderaPlusFormOpen={onMaderaPlusFormOpen}
            onMaderaPlusEnd={onMaderaPlusEnd}
            onNotificationClick={() => { }}
            onInterventionAdd={handleInterventionAdd}
            onInterventionSelect={(interventionId) => handleSelectIntervention(interventionId)}
            onVisitAdd={onVisitAdd}
            onVisitDelete={onVisitDelete}
          />
        }
      </Box>
    </BottomSheet>
  </Hidden>;
};

InterventionZoneBottomSheet.propTypes = {
  isOffline: PropTypes.bool,
  isMaderaPlusMode: PropTypes.bool,
  maderaPlusAvailableSpecies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    existences: PropTypes.shape({
      age: PropTypes.number,
      treeFeet: PropTypes.number,
      height: PropTypes.number,
      basometricArea: PropTypes.number,
      volumeWithBark: PropTypes.number,
      volumeWithoutBark: PropTypes.number,
      biomass: PropTypes.number,
    })
  })),
  prospectingPoints: prospectingPoints,
  role: PropTypes.oneOf(Object.values(ROLES_LABEL)),
  selectedInterventionZone: PropTypes.object,
  specie: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    existences: PropTypes.shape({
      age: PropTypes.number,
      treeFeet: PropTypes.number,
      height: PropTypes.number,
      basometricArea: PropTypes.number,
      volumeWithBark: PropTypes.number,
      volumeWithoutBark: PropTypes.number,
      biomass: PropTypes.number,
    })
  }),
  visitList: PropTypes.arrayOf(visit),
  onMaderaPlusFormOpen: PropTypes.func,
  onMaderaPlusEnd: PropTypes.func,
  onInterventionAdd: PropTypes.func,
  onInterventionSelect: PropTypes.func,
  onVisitAdd: PropTypes.func,
  onVisitDelete: PropTypes.func
};

export default InterventionZoneBottomSheet;